import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
import { StyleProp, View, ViewStyle } from 'react-native';

const MB_SVG_Location = React.memo(
  ({
    size = 13,
    containerStyle,
  }: {
    /**
     * The size of the component.
     */
    size?: number;

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={containerStyle}>
        <Svg width={size * (9 / 13)} height={size} viewBox="0 0 9 13" fill="none">
          <Path
            d="M4.038 12.258C.632 7.321 0 6.814 0 5a4.5 4.5 0 019 0c0 1.814-.632 2.321-4.038 7.258a.562.562 0 01-.925 0h.001zM4.5 6.875a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75z"
            fill="#333"
          />
        </Svg>
      </View>
    );
  }
);

export { MB_SVG_Location };
